import {Injectable} from '@angular/core';
import * as environment from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class BackendService {

    private local_backend_port: number = Number(environment.environment.backend_port);
    private local_backend_host: string = environment.environment.backend_host;
    private local_backend_path: string = environment.environment.backend_path;
    private local_backend_proto: string = environment.environment.backend_proto;

    constructor() {
    }

    getBackendUserLogOutUrl(): string {
    return this.getBackendBaseUrl() + "user/logout";
    }

    getBackendBaseUrl(): string {
        return this.local_backend_proto + "://" + this.local_backend_host + ":" + this.local_backend_port + this.local_backend_path;
    }

    getBackendDummyImage(): string {
        return this.getBackendBaseUrl() + "images/default/dummy.png";
    }
    getBackendUserLoginUrl(): string {
        return this.getBackendBaseUrl() + "user/login";
    }
    getBackendUserRegisterOrLoginWithOAuthUrl(): string {
        //todo: add link checker feature for all backend service provided urls << fail once directly after start <<
        return this.getBackendBaseUrl() + "user/loginWithOAuth";
    }
    getUserIdByToken(): string {
        return this.getBackendBaseUrl() + "user/getUserIdByToken";
    }
    startFollowBoard(): string {
        return this.getBackendBaseUrl() + "boards/follow/start";
    }
    stopFollowBoard(): string {
        return this.getBackendBaseUrl() + "boards/follow/stop";
    }
    statusFollowBoard(): string {
        return this.getBackendBaseUrl() + "boards/follow/status";
    }
    startFavoriteBoard(): string {
        return this.getBackendBaseUrl() + "boards/favorite/start";
    }
    stopFavoriteBoard(): string {
        return this.getBackendBaseUrl() + "boards/favorite/start";
    }
    statusFavoriteBoard(): string {
        return this.getBackendBaseUrl() + "boards/follow/status";
    }
    getBackendGetCurrentUserUrl(): string {
        return this.getBackendBaseUrl() + "user/getCurrentUser";
    }
    getHitCountForBoard(): string {
        return this.getBackendBaseUrl() + "boards/hits/count";
    }
    getBackendAllRelatedBoardsUrl(): string {
        return this.getBackendBaseUrl() + "user/board/getAllUserRelatedBoardsRequest";
    }
    getBackendAllRelatedBoardsUrlForUserID(user_id:number): string {
        return this.getBackendBaseUrl() + 'user/' + user_id +'/getUserRelatedBoards';
    }
    getBackendTokenIsValidUrl(): string {
        return this.getBackendBaseUrl() + "token/isValidToken";
    }
    getBackendgetFollowerCount(): string {
        return this.getBackendBaseUrl() + "boards/follow/count";
    }
    getBackendgetFollowerCountForUser(): string {
        return this.getBackendBaseUrl() + "boards/follow/countForUser";
    }
    getBackendgetFavoriteCount(): string {
        return this.getBackendBaseUrl() + "boards/favorite/count";
    }
    getBackendupdateUserStatus(): string {
        return this.getBackendBaseUrl() + "user/updateUserStatus";
    }
    getBackendgetTopicsforUser(): string {
        return this.getBackendBaseUrl() + "user/getTopicsByUserid";
    }
    getBackendStartTopic(): string {
        return this.getBackendBaseUrl() + "user/topics/start";
    }
    getBackendStopTopic(): string {
        return this.getBackendBaseUrl() + "user/topics/stop";
    }
    getBackendStatusTopic(): string {
        return this.getBackendBaseUrl() + "user/topics/status";
    }
    getBackendBoardByNameUrl(): string {
        return this.getBackendBaseUrl() + "boards/getByName?boardName=";
    }
    getBackendGetAllForSearchUrl(): string {
        return this.getBackendBaseUrl() + "boards/getAllForSearch";
    }
    getBackendGetAllForBoardsForLocalUser(): string {
        return this.getBackendBaseUrl() + "user/board/getAllUserRelatedBoardsRequest";
    }
    getBackendHitsForBoardID(): string {
        return this.getBackendBaseUrl() + "boards/hits/count";
    }
    getBackendgetNewHitsForBoardID(): string {
        return this.getBackendBaseUrl() + "boards/hits/new";
    }
    getBackendFollowerForBoardID(): string {
        return this.getBackendBaseUrl() + "boards/follow/count";
    }
    getBackendCommentCountForBoardID(): string {
        return this.getBackendBaseUrl() + "comment/board/count";
    }
    getBackendUpdateUserLevel(user_id): string {
        return this.getBackendBaseUrl() + "user/"+user_id+"/updateUserLevel";
    }
    getBackendUserIDByNameUrl(): string {
        return this.getBackendBaseUrl() + "user/getUserIdByUserName";
    }
    getBackendUserByIDUrl(user_id:number): string {
        return this.getBackendBaseUrl() + 'user/'+ user_id +'/get';
    }
    getBackendsetFollowNotification(): string {
        return this.getBackendBaseUrl() + "user/updateUserNotificationsFollower";
    }
    getBackendsetCommentNotification(): string {
        return this.getBackendBaseUrl() + "user/updateUserNotificationsComment";
    }
    getBackendsetProfilPrivacy(): string {
        return this.getBackendBaseUrl() + "user/updateUserProfilPrivacy";
    }
    getBackendBoardComments(): string {
        return this.getBackendBaseUrl() + "comment/board/get";
    }
    getBackendBoardCommentsLikeStatus(): string {
        return this.getBackendBaseUrl() + "comment/board/status";
    }
    getBackendBoardCommentsLikeStart(): string {
        return this.getBackendBaseUrl() + "comment/board/like_comment_start";
    }
    getBackendBoardCommentsLikeStop(): string {
        return this.getBackendBaseUrl() + "comment/board/like_comment_stop";
    }
    getBackendBoardDeleteComment(): string {
        return this.getBackendBaseUrl() + "comment/board/delete";
    }
    getBackendBoardDelete(): string {
        return this.getBackendBaseUrl() + "boards/deleteBoard";
    }
    getBackendBoardwriteComment(): string {
        return this.getBackendBaseUrl() + "comment/board/create";
    }
    getBackendBoardexplore(): string {
        return this.getBackendBaseUrl() + "boards/explore";
    }
    getBackendRegisterUser(): string {
        return this.getBackendBaseUrl() + "user/registerUser";
    }
    getBackendCheckUsername(): string {
        return this.getBackendBaseUrl() + "user/checkIfUsernameIsAvailable";
    }
    getnewFollowNotification(): string {
        return this.getBackendBaseUrl() + "boards/follow/unread_count";
    }
    getnewCommentNotificationCount(): string {
        return this.getBackendBaseUrl() + "comment/user/unread_count";
    }
    getallFollowerForNotification(): string {
        return this.getBackendBaseUrl() + "boards/follow/getFollowerFromOwnerId";
    }
    getallCommentsForNotification(): string {
        return this.getBackendBaseUrl() + "comment/getBoardCommentsFromOwnerId";
    }
    getBackendupdateFollowStatus(): string {
        return this.getBackendBaseUrl() + "user/updateUnreadFollowNotification";
    }
    getBackendupdateCommentStatus(): string {
        return this.getBackendBaseUrl() + "user/updateUnreadCommentNotification";
    }
    getBackendNotiAllFollowSetToRead(): string {
        return this.getBackendBaseUrl() + "user/updateUnreadAllFollowNotification";
    }
    getBackendNotiAllCommentSetToRead(): string {
        return this.getBackendBaseUrl() + "user/updateUnreadAllCommentNotification";
    }
    getBackendUpdateUserBasics(): string {
        return this.getBackendBaseUrl() + "user/updateCurrentUserDetails";
    }
    getBackendUpdateUserPassword(): string {
        return this.getBackendBaseUrl() + "user/setNewUserPasswordByToken";
    }
    getBackendCreateBoardUrl():string {
        return this.getBackendBaseUrl() + "boards/create";
    }
    getBackendAllTopics():string {
        return this.getBackendBaseUrl() + "topic/getAllTopics";
    }
    getBackendGetAllTweets():string {
        return this.getBackendBaseUrl() + "third_party/twitter/rest_api/users/tweets/getAllTweetsFromUser";
    }
    getCommentLikeState():string {
        return this.getBackendBaseUrl() + "comment/board/status";
    }
    getFollowerFromBoard():string {
        return this.getBackendBaseUrl() + "boards/follow/getFollowerFromBoardId";
    }
    getJokesFromBE():string {
        return this.getBackendBaseUrl() + "user/getJoke";
    }
    getPostForBoardsFromBE():string {
        return this.getBackendBaseUrl() + "boards/getPostForBoard";
    }
    getAffiliteLinksForBoardFromBE():string {
        return this.getBackendBaseUrl() + "boards/getAffiliteLinksForBoard";
    }
    createPostForBoards():string {
        return this.getBackendBaseUrl() + "boards/createPostForBoard";
    }
    getEmojis():string {
        return this.getBackendBaseUrl() + "boards/getAllEmojis";
    }
    sendContactMessage():string {
        return this.getBackendBaseUrl() + "contact/sendContactMessage";
    }
    verifiedStatus():string {
        return this.getBackendBaseUrl() + "contact/verifiedstatus";
    }
    boardPostLikeStart():string {
        return this.getBackendBaseUrl() + "board_post/board/startlike";
    }
    boardPostLikeStop():string {
        return this.getBackendBaseUrl() + "board_post/board/stoplike";
    }
    boardPostLikeStatus():string {
        return this.getBackendBaseUrl() + "board_post/board/likestatus";
    }
    backendHeartBeatUrl():string {
   return this.getBackendBaseUrl() + "heartbeat";
 }
     getBackendBoardImageUrl(board_image:string): string {
       return this.getBackendBaseUrl() + 'images/board_images/'+ board_image;
     }
     getBackendUserImageUrl(user_image_name:string): string {
         return this.getBackendBaseUrl() + 'images/user_images/'+ user_image_name;
     }
     getBackendDefaultImageUrl(default_image_name:string): string {
       return this.getBackendBaseUrl() + 'images/default/'+ default_image_name;
     }
     getBackendBoardFavoriteStatusUrl(): string {
       return this.getBackendBaseUrl() + 'boards/favorite/status';
     }
     getBackendFilesImagesSaveBase64EncodedImageUrl(): string {
         return this.getBackendBaseUrl() + 'files/images/saveBase64EncodedImage';
     }
     getBackendFilesImagesRetrieveBase64EncodedImageUrl(): string {
         return this.getBackendBaseUrl() + 'files/images/retrieveBase64EncodedImage';
     }
     getBackendThirdPartyRestApiTwitterUsersGetUserProfilesUrl(): string {
         return this.getBackendBaseUrl() + 'third_party/twitter/rest_api/users/getUserProfiles';
     }
     getBackendThirdPartyRestApiTwitterGetTweetsByHashtags(): string {
         return this.getBackendBaseUrl() + 'third_party/twitter/rest_api/users/tweets/getAllTweetsRelatedToHashtag';
     }
     getcollectiosFromUser(): string {
         return this.getBackendBaseUrl() + 'user/kollections/getAll';
     }
     createNewKollection(): string {
         return this.getBackendBaseUrl() + 'kollections/create';
     }
     getBackendThirdPartyRestApiSpotifyAutorization():string{
      return this.getBackendBaseUrl() + 'third_party/spotify/spotifyAuthorization';
     }
     getBackendStopKollektionRelation():string{
      return this.getBackendBaseUrl() + 'kollections/stop_relation';
     }
     getBackendStartKollektionRelation():string{
      return this.getBackendBaseUrl() + 'kollections/start_relation';
     }
     getBackendStatusKollektionRelation():string{
      return this.getBackendBaseUrl() + 'kollections/status_relation';
     }
     getBackendGetAllKollektionRelation(kollection_id:number):string{
      return this.getBackendBaseUrl() + 'kollections/'+ kollection_id +'/get';
     }
     getBackendDeleteKollektion(kollection_id):string{
      return this.getBackendBaseUrl() + 'kollections/deleteKollection';
     }
     getBackendDeleteboardPost(board_post_id):string{
      return this.getBackendBaseUrl() + 'board_post/board/delete';
     }
     getBackendBoardEditUrl(board_id:number): string {
       return this.getBackendBaseUrl() + "boards/" + board_id + "/edit";
     }
     getuserContactMessages(): string {
       return this.getBackendBaseUrl() + "user/getuserMessages";
     }
     getuserContactMessagesUpdateStatus(): string {
       return this.getBackendBaseUrl() + "user/updateUserMessage";
     }
     createNewAffiliateLink(): string {
       return this.getBackendBaseUrl() + "boards/createAffiliteBoard";
     }
     checkBoardname(): string {
       return this.getBackendBaseUrl() + "user/checkIfBoardnameIsAvailable";
     }
     getVibrantfromImage(): string {
       return this.getBackendBaseUrl() + "boards/getvibrantColor";
     }
     getTiktokProfil(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getUserProfile";
     }
     getTiktokFeedsForProfil(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getUserFeedByUserId";
     }
     getTiktokFeedsViaHashtag(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getHashTag";
     }
     resetUserPassword(): string {
       return this.getBackendBaseUrl() + "user/resetPassword";
     }
     getTiktokUserRapidapi(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getUserProfilRapidapi";
     }
     getTiktokUserFeedRapidapi(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getUserFeed";
     }
     getTiktokHashtagFeedRapidapi(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getHashtagFeedRapidapi";
     }
     searchbyBoardname(): string {
       return this.getBackendBaseUrl() + "boards/searchByBoardName";
     }
     getFeedsFromFollowingBoards(): string {
       return this.getBackendBaseUrl() + "user/getFeedsFromFollowingBoards";
     }
     videoUpload(): string {
       return this.getBackendBaseUrl() + "files/videos/saveFormUploadedMP4EncodedVideo";
     }
     getTTUser(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getUserInfo";
     }
     getTTUserFeed(): string {
       return this.getBackendBaseUrl() + "third_party/tiktok/getUserFeed";
     }
     getSearchUserByUserName(): string {
       return this.getBackendBaseUrl() + "user/searchByUserName";
     }
     getRelationRequests(): string {
       return this.getBackendBaseUrl() + "user/relation/getRelationRequests";
     }
     createNewRelation(): string {
       return this.getBackendBaseUrl() + "user/relation/createNewRelation";
     }
     getRelationFromMe(): string {
       return this.getBackendBaseUrl() + "user/relation/getRelationFromMe";
     }
     deleteRelation(): string {
       return this.getBackendBaseUrl() + "user/relation/deleteRelation";
     }
     dontAcceptRelation(): string {
       return this.getBackendBaseUrl() + "user/relation/dontAcceptRelation";
     }
     acceptRelation(): string {
       return this.getBackendBaseUrl() + "user/relation/acceptRelation";
     }
     relation_unread_count(): string {
       return this.getBackendBaseUrl() + "user/relation/relation_unread_count";
     }
     checkUserHaveSendRelationRequest(): string {
       return this.getBackendBaseUrl() + "user/relation/checkUserHaveSendRelationRequest";
     }
     checkRelationStatus(): string {
       return this.getBackendBaseUrl() + "user/relation/checkRelationStatus";
     }
     getUserFeedsInsta(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/getUserFeeds";
     }
     getsearchUserInsta(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/searchUser";
     }
     youHaveSendRelationRequest(): string {
       return this.getBackendBaseUrl() + "user/relation/youHaveSendRelationRequest";
     }
     getUserMessageCount(): string {
       return this.getBackendBaseUrl() + "user/message/count_user";
     }
     getInstaUserFeedRapidapi(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/getUserFeedRapidapi";
     }
     instaSearchUserFeedRapidapi(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/userSearchRapidapi";
     }
     getUserFeedByIdRapidapi(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/getUserFeedByIdRapidapi";
     }
     getCancelDeleteAccount(): string {
       return this.getBackendBaseUrl() + "contact/cancelDeleteAccount";
     }
     getUserFeedSSovid(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/getUserFeedSSovid";
     }
     getUserSearchSSovid(): string {
       return this.getBackendBaseUrl() + "third_party/instagram/userSearchSSovid";
     }
     checkIfBackupfeedExist(): string {
       return this.getBackendBaseUrl() + "boards/socialMediaFeedBackup/checkIfBackupfeedExist";
     }
     saveSocialMediaFeed(): string {
       return this.getBackendBaseUrl() + "boards/socialMediaFeedBackup/saveSocialMediaFeed";
     }
     updateBackupFeed(): string {
       return this.getBackendBaseUrl() + "boards/socialMediaFeedBackup/updateBackupFeed";
     }
     getAllBoardBackupFeedsByBoardId(): string {
       return this.getBackendBaseUrl() + "boards/socialMediaFeedBackup/getAllBoardBackupFeedsByBoardId";
     }
     getAllBoardBackupFeedsByBoardIdAndProviderId(): string {
       return this.getBackendBaseUrl() + "boards/socialMediaFeedBackup/getAllBoardBackupFeedsByBoardIdAndProviderId";
     }
     getAllExistsAwards(): string {
       return this.getBackendBaseUrl() + "awards/getAllExistsAwards";
     }
     getAllAwardsForUserId(): string {
       return this.getBackendBaseUrl() + "awards/getAllAwardsForUserId";
     }
     checkAndWriteUserWithMostViewsOfBoard(): string {
       return this.getBackendBaseUrl() + "awards/checkAndWriteUserWithMostViewsOfBoard";
     }
     checkAndWriteUserWithMostFollowerInBoards(): string {
       return this.getBackendBaseUrl() + "awards/checkAndWriteUserWithMostFollowerInBoards";
     }
     checkAndWriteUserWithMostCreatedBoards(): string {
       return this.getBackendBaseUrl() + "awards/checkAndWriteUserWithMostCreatedBoards";
     }
     checkAndWriteUserCreatetBoardAward(): string {
       return this.getBackendBaseUrl() + "awards/checkAndWriteUserCreatetBoardAward";
     }
     get_all_users_MSG_by_id(): string {
       return this.getBackendBaseUrl() + "user/message/get_all_users_by_id";
     }

     getRandomImageUrlForBoardAvatar():string{
        return this.getBackendBaseUrl() + "files/images/createRandomSquaresBoardAvatar"
     }
     searchBoardbyTag():string{
        return this.getBackendBaseUrl() + "boards/searchBoardbyTag"
     }
     searchFacebookProfiles():string{
        return this.getBackendBaseUrl() + "third_party/facebook/searchFacebookProfiles"
     }
     facebookProfileFeed():string{
        return this.getBackendBaseUrl() + "third_party/facebook/facebookProfileFeed"
     }
     instahashtagfeed():string{
        return this.getBackendBaseUrl() + "third_party/instagram/getHashtagFeedRapidapi"
     }
     replyContactMessage():string{
        return this.getBackendBaseUrl() + "contact/replyContactMessage"
     }
     getAllContactRequest():string{
        return this.getBackendBaseUrl() + "contact/getAllContactRequest"
     }
    updateStatusFromKontaktMessages(): string {
        return this.getBackendBaseUrl() + "contact/updateStatusFromKontaktMessages";
    }
    getAllKontaktMessages(): string {
        return this.getBackendBaseUrl() + "contact/getAllKontaktMessages";
    }
    twitchAuthorization(): string {
        return this.getBackendBaseUrl() + "third_party/twitch/twitchAuthorization";
    }
    getRandomsForHome(): string {
        return this.getBackendBaseUrl() + "boards/getRandomsForHome";
    }







}
